(function () {
  'use strict';

  angular
    .module('activeInactiveCrewList', [
      'ui.router'
    ]);
}());
